import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=768646c4&scoped=true&"
import script from "./Attachment.vue?vue&type=script&lang=js&"
export * from "./Attachment.vue?vue&type=script&lang=js&"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=768646c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768646c4",
  null
  
)

export default component.exports